<template>
  <v-tooltip top v-if='timeline'>
    <template v-slot:activator='{ on }'>
      <v-chip
        v-on='on'
        :small='small'
        :x-small='xSmall'
        label
        :color='status.color'
        :dark='status.dark'
        :class='position'
      >
        {{ status.text }}
      </v-chip>
    </template>
    <span>{{ status.tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'estimate-status-chip',
  props: {
    timeline: {
      required: true
    },
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    xSmall: {
      required: false,
      type: Boolean,
      default: false
    },
    left: {
      required: false,
      type: Boolean,
      default: false
    },
    right: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    position () {
      let ret = ''
      if (this.left) {
        ret += ' mr-2'
      }
      if (this.right) {
        ret += ' ml-2'
      }
      return ret
    },
    status () {
      let ret = {}
      switch (this.timeline) {
        case 'PRI':
          ret = { text: 'PRI', tooltip: 'Priority', dark: false, color: 'error' }
          break
        case 'BM8':
          ret = { text: 'BM8', tooltip: 'Before May 8th', dark: false, color: 'error' }
          break
        case 'PO1':
          ret = { text: 'PO1', tooltip: 'Post October 1st', dark: true, color: 'purple' }
          break
        case 'PS20':
          ret = { text: 'PS20', tooltip: 'Post September 20th', dark: true, color: 'purple lighten-2' }
          break
        case 'ERS10':
          ret = { text: 'ERS10', tooltip: 'Early Residential', dark: false, color: 'yellow' }
          break
        case 'NTL':
          ret = { text: 'NTL', tooltip: 'Normal Timeline', dark: true, color: 'info'}
          break
        case 'URGENT':
          ret = { text: 'URGENT', tooltip: 'Urgent Timeline', dark: true, color: 'error'}
          break;
        default:
          ret = { text: '?', tooltip: 'Unknown timeline', dark: false, color: 'warning' }
          break
      }
      return ret
    }
  }
}
</script>
